/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_OptionExerciseImport_DownloadOptionExerciseImportTemplateDto } from '../models/Wealthlane_AwardService_Dtos_OptionExerciseImport_DownloadOptionExerciseImportTemplateDto';
import type { Wealthlane_AwardService_Dtos_OptionExerciseImport_OptionExerciseImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExerciseImport_OptionExerciseImportResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImportOptionExerciseService {

    /**
     * @returns Wealthlane_AwardService_Dtos_OptionExerciseImport_DownloadOptionExerciseImportTemplateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportOptionExerciseDownloadTemplate(): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExerciseImport_DownloadOptionExerciseImportTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-option-exercise/download-template',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_OptionExerciseImport_OptionExerciseImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportOptionExerciseOptionExerciseImportRequest(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExerciseImport_OptionExerciseImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-option-exercise/option-exercise-import-request',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
